var map = {
	"./favicon0.png": "9DSJ",
	"./favicon1.png": "tMnL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Hdke";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index ^\.\/favicon.*\.png$
// module id = Hdke
// module chunks = 3